import { common } from '@/locales/ar/common';
import { auth } from '@/locales/ar/auth';
import { navigation } from '@/locales/ar/navigation';
import { profile } from '@/locales/ar/profile';
import { workspace } from '@/locales/ar/workspace';
import { billing } from '@/locales/ar/billing';
import { work } from '@/locales/ar/work';
import { assets } from '@/locales/ar/assets';
import { inspections } from '@/locales/ar/inspections';
import { jobs } from '@/locales/ar/jobs';
import { lifecycleGate } from '@/locales/ar/lifecycleGate';
import { contacts } from '@/locales/ar/contacts';
import { copilot } from '@/locales/ar/copilot';
import { home } from '@/locales/ar/home';
import { assistant } from '@/locales/ar/assistant';
import { activity } from '@/locales/ar/activity';
import { schedule } from '@/locales/ar/schedule';
import { sites } from '@/locales/ar/sites';
import { timeline } from '@/locales/ar/timeline';
import { compliance } from '@/locales/ar/compliance';
import { guide } from '@/locales/ar/guide';
import { packs } from '@/locales/ar/packs';
import { notifications } from '@/locales/ar/notifications';
import { enUSResources } from '@/locales/en-US';
import { mergeLocaleResources } from '@/locales/mergeLocaleResources';

export const arResources = mergeLocaleResources(enUSResources, {
  common,
  auth,
  navigation,
  profile,
  workspace,
  billing,
  work,
  assets,
  inspections,
  jobs,
  lifecycleGate,
  contacts,
  copilot,
  home,
  assistant,
  activity,
  schedule,
  sites,
  timeline,
  compliance,
  guide,
  packs,
  notifications,
} as const);
